import type {
  SMPPaymentMethodV2,
  IPaymentMethodKind,
} from '@viome/viome-base/src/usecase/SMP/SMP.model';
import {
  PaymentMethodKind,
  PaymentMethodTypeV2,
} from '@viome/viome-base/src/usecase/SMP/SMP.model';

export const getPaymentMethodKind = (
  pm?: SMPPaymentMethodV2 | null,
): IPaymentMethodKind => {
  if (!pm) return PaymentMethodKind.UNKNOWN;
  if (pm.type === PaymentMethodTypeV2.CARD || pm.card) return PaymentMethodKind.CARD;
  if (pm.type === PaymentMethodTypeV2.PAYPAL || pm.payPal) return PaymentMethodKind.PAYPAL;
  return PaymentMethodKind.UNKNOWN;
};

export const formatCardExpiry = (
  card?: { expiryMonth: number; expiryYear: number } | null,
): string => {
  if (!card) return '—';
  if (!Number.isFinite(card.expiryMonth) || !Number.isFinite(card.expiryYear)) return '—';
  const mm = String(card.expiryMonth).padStart(2, '0');
  const yy = String(card.expiryYear % 100).padStart(2, '0');
  return `${mm} / ${yy}`;
};

export const formatLastChargeDate = (iso?: string | null): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

export const formatNextChargeDate = (s: {
  next_payment_datetime?: string | null;
}): string => formatLastChargeDate(s.next_payment_datetime);

export const getBrandDisplayName = (brand?: string | null): string => {
  if (!brand) return 'Card';
  const b = brand.toLowerCase();
  if (b === 'visa') return 'Visa';
  if (b === 'mastercard' || b === 'mc') return 'Mastercard';
  if (b === 'amex' || b === 'american_express') return 'American Express';
  if (b === 'discover') return 'Discover';
  return brand.charAt(0).toUpperCase() + brand.slice(1);
};
